import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing.space16,
    borderRadius: theme.radius.small,
  },
  currentImage: {
    height: 100,
    objectFit: "contain",
    paddingBottom: theme.spacing.space8,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space8,
  },
  description: {
    paddingBottom: theme.spacing.space8,
  },
}));
